// generated by srcset-codegen
import src from "./robin.png";

const width = 64;
const height = 64;
export default { src, width, height };
